










































































































import Vue from "vue";
import { default as moment, Moment } from "moment-timezone";
import { forkJoin } from "rxjs";
import { Dictionary } from "vue-router/types/router";
import { Dame, currentTimestamp, MONATSNAMEN } from "@/api/Termine";
import { Studio } from "@/api/Studio";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import MonatsabschlussEdit from "@/components/MonatsabschlussEdit.vue";

type Modus = "Auswahl" | "DameDetails" | "Editieren";

export default Vue.extend({
  name: "Monatsabschluss",
  components: {
    ConfirmDialog,
    MonatsabschlussEdit,
  },
  data() {
    return {
      modus: "Auswahl" as Modus,
      zeit: {} as Moment,
      monat: 1,
      jahr: 2021,
      dameIndex: -1,
      damenDesMonats: [] as Dame[],
      studio: null as Studio | null,
      studios: [] as Studio[],
    };
  },
  created() {
    const routeParams = this.$route.params;

    const updateParameters = (studios: Studio[]) => {
      this.studios = studios;
      const gewaehltesStudio = this.$store.getters["gewaehltesStudio"];

      if (!gewaehltesStudio && this.studios.length) {
        this.studio = this.studios[0];
        this.$store.dispatch("selectStudio", { studio: this.studio });
      }

      if (routeParams) {
        if (routeParams.datum) {
          this.zeit = moment(routeParams.datum, "YYYY-MM-DD");
        }
        if (routeParams.studio) {
          const studioBezeichner = routeParams.studio;
          const filteredStudios = studios.filter(
            (studio: Studio) => studio.bezeichner == studioBezeichner
          );
          if (filteredStudios.length) {
            this.studio = filteredStudios[0];
            this.$store.dispatch("selectStudio", { studio: this.studio });
          }
        }
      }
    };

    this.$store.dispatch("appLoading", true);

    const studios: Studio[] = this.$store.getters["studios"];
    if (Array.isArray(studios) && studios.length >= 1) {
      updateParameters(studios);
      this.$store.dispatch("appLoading", false);
    } else {
      this.$znaApi.getStudios().subscribe(
        (studios) => {
          updateParameters(studios);
          this.$store.dispatch("studiosGeladen", { studios });
          this.$store.dispatch("appLoading", false);
        },
        (error: string) => {
          this.$toast.add({
            severity: "error",
            summary: "Laden der Studios fehlgeschlagen",
            detail: error,
            life: 3000,
          });
          this.$store.dispatch("appLoading", false);
        }
      );
    }

    const gewaehlterTag = this.$store.getters["gewaehltesDatum"];
    if (gewaehlterTag) {
      this.zeit = moment(gewaehlterTag, "YYYY-MM-DD");
    } else {
      this.zeit = currentTimestamp();
    }
    this.updateZeit();
  },
  mounted() {
    this.updateZeit();

    const routeParams = this.$route.params;
    const studio = this.$store.getters["gewaehltesStudio"];
    const params: Dictionary<string> = {};
    let nextRouteName = "";
    if (!routeParams || !routeParams.studio) {
      if (studio) {
        nextRouteName = "Monatsabschluss-mit-Studio";
        params["studio"] = studio.bezeichner;
      }
    }
    if (!routeParams || !routeParams.datum) {
      let datum = this.$store.getters["gewaehltesDatum"];
      if (!datum) {
        datum = currentTimestamp().format("YYYY-MM-DD");
        this.$store.dispatch("selectDatum", { datum });
      }
      nextRouteName = "Monatsabschluss-mit-Studio-und-Datum";
      params["datum"] = datum;
    }

    if (nextRouteName !== "") {
      this.$router.push({
        name: nextRouteName,
        params,
      }).catch(failure => {
        // Ignore if isNavigationFailure(failure, NavigationFailureType.redirected)
      });
      return;
    }
  },
  computed: {
    ueberschriftAuswahl() {
      return `Monatsübersicht für ${MONATSNAMEN[(this as any).monat]} ${
        (this as any).jahr
      }`;
    },
    darfTageLoeschen() {
      return this.$znaApi.darfTageLoeschen();
    },
  },
  watch: {
    "$route.params.datum": function(datum) {
      console.debug("Monatsabschluss / Datum wechselt: " + datum);
      const zeit = moment(datum, "YYYY-MM-DD");
      if (zeit.isValid()) {
        this.zeit = zeit;
      } else {
        this.zeit = currentTimestamp();
      }
      this.updateZeit();
    },
    "$route.params.studio": function(studio) {
      console.debug("Monatsabschluss / Studio-Bezeichner wechselt: " + studio);
      const studioKandidaten = this.studios.filter(
        (s) => s.bezeichner == studio
      );
      this.studio = studioKandidaten.length ? studioKandidaten[0] : null;
    },
    monat: function(monat) {
      const datum = this.zeit.format("YYYY-MM-DD");
      console.debug("Monatsabschluss / Datum wechselt: " + datum);
      this.$nextTick().then(() => this.checkChangeRoute(this.studio));
    },
    studio: function() {
      console.debug(
        "Monatsabschluss / Studio-Bezeichner wechselt: " +
          this.studio?.bezeichner
      );
      this.$nextTick().then(() => this.checkChangeRoute(this.studio));
    },
  },
  methods: {
    checkChangeRoute(studio: Studio | null) {
      if (this.zeit && this.zeit.isValid()) {
        const params: Dictionary<string> = {
          datum: this.zeit.format("YYYY-MM-DD"),
        };
        let nextRouteName = "Monatsabschluss-mit-Studio";
        let log = "Wechsle zu Monatsabschluss-mit-Studio";
        if (studio) {
          nextRouteName = "Monatsabschluss-mit-Studio-und-Datum";
          log = "Wechsle zu Monatsabschluss-mit-Studio-und-Datum";
          params["studio"] = studio.bezeichner;
        }
        if (
          this.$route.name != nextRouteName ||
          this.$route.params.studio !== params.studio ||
          this.$route.params.datum !== params.datum
        ) {
          console.log(log);
          this.$router.push({
            name: nextRouteName,
            params,
          });
        }
      }
    },
    auswahl() {
      this.modus = "Auswahl";
    },
    dameMonatsblattEditieren() {
      this.modus = "DameDetails";
    },
    setMonth(offset: number) {
      if (offset < 0) {
        this.zeit.subtract(1, "month");
      } else if (offset > 0) {
        this.zeit.add(1, "month");
      }
      console.log("Monat verändert");
      this.updateZeit();
    },
    updateZeit() {
      if (this.zeit && this.zeit.isValid && this.zeit.isValid()) {
        this.monat = this.zeit.month();
        this.jahr = this.zeit.year();
        this.$store.dispatch("selectDatum", {
          datum: this.zeit.format("YYYY-MM-DD"),
        });
      }
    },
    studioGewaehlt() {
      this.$store.dispatch("selectStudio", { studio: this.studio });
    },
    damenDesMonatsSelected(damenDesMonats: Dame[]) {
      this.damenDesMonats = damenDesMonats;
    },
    dameSelected(dameIndex: number) {
      this.dameIndex = dameIndex;
      this.dameMonatsblattEditieren();
      console.log("Neue Dame gewählt");
    },
    monatsabschlussNeuBerechnenGewaehltesStudio() {
      const monat = moment(new Date(this.jahr, this.monat, 1, 12));
      this.$store.dispatch("appLoading", true);
      this.$znaApi.monatsabschlussNeuBerechnen(this.studio as Studio, monat, true, undefined)
        .subscribe(monatsdaten => {
          (this.$refs.uebersicht as any).updateData();
        });
    },
    monatsabschlussNeuBerechnenAlleStudios() {
      const studios: Studio[] = this.$store.getters["studios"];
      const monat = moment(new Date(this.jahr, this.monat, 1, 12));
      this.$store.dispatch("appLoading", true);
      const observables = studios.map(studio => this.$znaApi.monatsabschlussNeuBerechnen(studio, monat, true, undefined));
      forkJoin(...observables)      
        .subscribe(monatsdatenAllerStudios => {
          (this.$refs.uebersicht as any).updateData();
        });
    },
    monatsabschlussEditieren() {
      this.modus = "Editieren";
    },
    generateSammelanmeldung() {
      (this.$refs.uebersicht as any).createStudioSammelanmeldungExport();
    },
    buchungsdatenLoeschen() {
      this.$nextTick(() => {
        (this.$refs.confirmDialog as any).confirm(
            "delete",
            "Panikaktion: ALLE Buchungsdaten löschen?",
            "Bitte bewahren Sie einen kühlen Kopf!<br>"
            + "\n\nMöchten Sie jetzt alle bisher gebuchten Termine und Abrechnungen löschen?"
          ).then(() => {
            this.$nextTick(() => {
              (this.$refs.confirmDialog as any).confirm(
                  "delete",
                  "Bestätigung: ALLE Buchungsdaten löschen?",
                  "Dies ist die <strong>letzte Rückfrage</strong>!<br>"
                  + "\n\nZur Erinnerung: Es gibt <strong>keine Datensicherung</strong>!<br>"
                  + "\n\nSind Sie wirklich sicher, dass Sie jetzt <strong>alle Buchungsdaten</strong> (Termine und Abrechnungen) ALLER Studios <strong>unwiederbringlich</strong> aus dem System <strong>löschen</strong> möchten?"
                ).then(() => {
                  this.$nextTick(() => {
                    this.$store.dispatch("appLoading", true);
                    this.$znaApi
                      .alleBuchungsdatenLoeschen()
                      .subscribe(
                        () => {
                          this.updateZeit();
                          this.$toast.add({
                            severity: 'success',
                            summary: 'Datenlöschung erfolgreich ausgeführt',
                            detail: 'Alle Buchungsdaten gelöscht.\nTages- und Monatsabschlüsse zurückgesetzt.',
                            life: 5000
                          });
                        }, error => {
                          this.$toast.add({
                            severity: 'error',
                            summary: 'Fehler bei Datenlöschung',
                            detail: 'Leider kam es bei der Datenlöschung zu einem Fehler.\n\nBitte wenden Sie sich an den Programmierer und geben Sie genau an, was Sie getan haben und weshalb.',
                            life: 5000
                          });
                          this.$store.dispatch("appLoading", false);
                        });
                    });
                },
                () => {
                  this.$toast.add({
                    severity: 'success',
                    summary: 'Datenlöschung abgebrochen',
                    detail: 'Puh! Das war knapp!\n\nEs wurden keine Daten gelöscht.',
                    life: 5000
                  });
                  this.$store.dispatch("appLoading", false);
                });
            });
          },
          () => {
            this.$toast.add({
              severity: 'success',
              summary: 'Datenlöschung abgebrochen',
              detail: 'Okay, Schwein gehabt.\n\nBitte bei dieser Funktion wirklich aufpassen und einen kühlen Kopf bewahren.',
              life: 5000
            });
            this.$store.dispatch("appLoading", false);
          });
      });
    },
  },
});
